import { get } from "lodash";
import apiInstance from "../api";
import endPoints from "../endpoints";

export const getAllCounts = () => {
  return apiInstance().get(endPoints.home.getTileCount);
};

export const getHomePageDetails = () => {
  return apiInstance().get(endPoints.home.get);
};
